import React, { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import classes from '../styles.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('file', classes);

type Props = {
  id?: string;
  title: React.ReactNode;
  subtitle?: string;
  badge?: string | number;
  defaultOpen?: boolean;
  variant?: 'brief' | 'risk' | 'table';
  children: React.ReactNode;
};

const VideoInsightsAccordion = ({
  id,
  title,
  subtitle,
  badge,
  defaultOpen = false,
  variant = 'brief',
  children,
}: Props) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <section
      id={id}
      className={cn('vi-accordion', { [variant]: true, open })}
    >
      <button
        type="button"
        className={cn('vi-accordion-head')}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(prev => !prev)}
      >
        <span className={cn('vi-accordion-head-main')}>
          {badge != null && (
            <span className={cn('vi-accordion-badge')} aria-hidden>
              {badge}
            </span>
          )}
          <span className={cn('vi-accordion-titles')}>
            <span className={cn('vi-accordion-title')}>{title}</span>
            {subtitle && (
              <span className={cn('vi-accordion-subtitle')}>{subtitle}</span>
            )}
          </span>
        </span>
        <ChevronDown
          size={16}
          className={cn('vi-accordion-chevron')}
          aria-hidden
        />
      </button>
      {open && (
        <div id={panelId} className={cn('vi-accordion-body')}>
          {children}
        </div>
      )}
    </section>
  );
};

export default VideoInsightsAccordion;
